import GOT from './GOT';

export default class AuthorityUtil
{
	static getXmlType2SCacheItem(menuItemId,innerId,type,auType='2')
	{
		var result = {};
		var userInfos = window.uesrInfos?window.userInfos:window.parent.window.userInfos;
		if(userInfos)
		{
			let userAus = userInfos.userAus;
			if(userAus)
			{
				let userAu = userAus[menuItemId + "." + innerId];
				if(userAu)
				{
					var attr = type;
					result["isDefault"] = false;
					result["result"] = (userAu[attr] || userAu[attr]=="true");
					result["isForbidden"] = (userAu["isForbidden"] || userAu["isForbidden"]=="true");
					return result;
				}
			}
		}
		
		if(menuItemId == "-1")
		{
			result["isDefault"] = true;result["result"] = true;return result;
		}
		var formNode = AuthorityUtil.xmlType2SCache[menuItemId];
		if(formNode == null)
		{
			result["isDefault"] = true;result["result"] = true;return result;
		}
		
		var _key = auType + "_" + menuItemId + "." + innerId;
		var singleNode = formNode[_key];
		if(singleNode == null)
		{
			result["isDefault"] = true;
			result["result"] = true;
			return result;
		}

		var attr = type;
		result["isDefault"] = false;
		result["result"] = (singleNode[attr] || singleNode[attr]=="true");
		result["isForbidden"] = (singleNode["isForbidden"] || singleNode["isForbidden"]=="true");
	
		return result;
	}

	static mergeAuthorityList(a,selfAuthMerge=null)
	{
		if(a==null || a.length==0)
			return null;
		
		var xmlType2Cache = {};
		var visible;
		var query;
		var exp;
		var edit;
		var save;
		var _new;
		var del;
		for(var i=0;i<a.length;i++)
		{
			var o = a[i];
			var type = o.authorityNodeType;
			var isForbidden = true;
			visible = o.authorityType_Visible;
			if(o.authorityType_Visible && isForbidden)isForbidden = false;
			query = o.authorityType_Query;
			if(o.authorityType_Query && isForbidden)isForbidden = false;
			exp = o.authorityType_Export;
			if(o.authorityType_Export && isForbidden)isForbidden = false;
			edit = o.authorityType_Edit;
			if(o.authorityType_Edit && isForbidden)isForbidden = false;
			save = o.authorityType_Save;
			if(o.authorityType_Save && isForbidden)isForbidden = false;
			_new = o.authorityType_New;
			if(o.authorityType_New && isForbidden)isForbidden = false;
			del = o.authorityType_Delete;
			if(o.authorityType_Delete && isForbidden)isForbidden = false;
			var _key;
			
			if(type == 2 || type == 3)
			{
				_key = type + "_" + o.authorityMenuItemId + "." + o.authorityFormItemId;
			}
			else
			{
				// throw new Error("initFormItemListCache type must be 2 or 3");
				continue;
			}
			
			if(!xmlType2Cache.hasOwnProperty(_key))
			{
				var node = {};node.type = type;node.key=_key;node.visible = visible;
				node.query = query;node["exp"] = exp;node.edit = edit;node.save=save;node._new=_new;node.del=del;node.isForbidden = isForbidden;
				
				xmlType2Cache[_key] = node;
			}
			else
			{
				if(selfAuthMerge){
					var node = {};node.type = type;node.key=_key;node.visible = visible;
					node.query = query;node["exp"] = exp;node.edit = edit;node.save=save;node._new=_new;node.del=del;node.isForbidden = isForbidden;
					
					xmlType2Cache[_key] = node
				}else{

					AuthorityUtil.setUniqueKey(xmlType2Cache[_key],visible,query,exp,edit,save,_new,del);
				}
				
			}
		}
		
		return xmlType2Cache;
	}

	static setUniqueKey(node,visible,query,exp,edit,save,_new,del)
	{
		if(visible == "true")
		{
			node.visible = visible;node.isForbidden = false;
		}
		if(query == "true")
		{
			node.query = query;node.isForbidden = false;
		}
		if(exp == "true")
		{
			node.exp = exp;node.isForbidden = false;
		}
		if(edit == "true")
		{
			node.edit = edit;node.isForbidden = false;
		}
		if(save == "true")
		{
			node.save = save;node.isForbidden = false;
		}
		if(_new == "true")
		{
			node._new = _new;node.isForbidden = false;
		}
		if(del == "true")
		{
			node.del = del;node.isForbidden = false;
		}
	}

	static xmlType2SCache = {};

	static setAuthorityMem(menuItemId,node)
	{
		AuthorityUtil.xmlType2SCache[menuItemId] = node;
	}


	static setUniqueKey(node,visible,query,exp,edit,save,_new,del)
	{
		if(visible == true)
		{
			node.visible = visible;node.isForbidden = false;
		}
		if(query == true)
		{
			node.query = query;node.isForbidden = false;
		}
		if(exp == true)
		{
			node.exp = exp;node.isForbidden = false;
		}
		if(edit == true)
		{
			node.edit = edit;node.isForbidden = false;
		}
		if(save == true)
		{
			node.save = save;node.isForbidden = false;
		}
		if(_new == true)
		{
			node._new = _new;node.isForbidden = false;
		}
		if(del == true)
		{
			node.del = del;node.isForbidden = false;
		}
	}

	static initMenuListCache(a,menuItemId = null)
	{
		if(!a)
			return;
		var xmlType0Cache = {};
		var xmlType1Cache = {};
		var xmlType1OrigCache = {};
		var xmlTypeuserOrigCache=[];
		var visible;
		var query;
		var exp;
		var edit;
		var save;
		var _new;
		var del;
		var userId;
		for(var i=0;i<a.length;i++)
		{
			var o = a[i];
			var type = o.authorityNodeType;
			visible = o.authorityType_Visible;
			query = o.authorityType_Query;
			exp = o.authorityType_Export;
			edit = o.authorityType_Edit;
			save = o.authorityType_Save;
			_new = o.authorityType_New;
			del = o.authorityType_Delete;
			if(o.userId){
				userId = o.userId;
				xmlTypeuserOrigCache.push(o);
			}
			var _key;var item;
			if(type == 0)
			{
				_key = o.authorityModuleId;
				item = xmlType0Cache[_key]; 	
			}
			else if(type == 1)
			{
				_key = o.authorityModuleId + "." + o.authorityMenuItemId;
				item = xmlType1Cache[_key];
			}

			let _userGroupId = o.userGroupId;
			if(_userGroupId && !xmlType1OrigCache[_userGroupId])
			{
				xmlType1OrigCache[_userGroupId] = {};
			}

			var node = {};node.visible = visible;node.query = query;node.exp = exp;node.edit = edit;
				node.save = save;node._new = _new;node.del = del;node.userGroupId=_userGroupId;
			if(_userGroupId)
				xmlType1OrigCache[_userGroupId][_key] = node;
		
			if(!item || !_userGroupId)
			{
				if(type == 0)
					xmlType0Cache[_key] = Object.assign({},node);
				else if(type == 1)
					xmlType1Cache[_key] = Object.assign({},node);
			}
			else
			{
				AuthorityUtil.setUniqueKey(item,visible,query,exp,edit,save,_new,del);
				
			}
		}
		
		xmlType1OrigCache[userId+"group"]=xmlType1Cache;
		window.xmlType0SCache = AuthorityUtil.xmlType0SCache = xmlType0Cache;
		window.xmlType1SCache = AuthorityUtil.xmlType1SCache = xmlType1Cache;
		window.xmlType1OrigCache = AuthorityUtil.xmlType1OrigCache = xmlType1OrigCache;
		window.xmlTypeuserOrigCache =xmlTypeuserOrigCache;
	
	}

	static xmlType0SCache;
	static xmlType1SCache;
	//保留没有经过权限合并的原始数据 用于画面权限合并之前判断是否该补全为查询权限 若为单用户组 则该缓存应无用
	//该用户组不含用户权限自动生成的组 用户权限自动生成的组为虚拟组
	static xmlType1OrigCache;

	static getXmlType0SCache()
	{
		if(AuthorityUtil.xmlType0SCache)
		{
			return AuthorityUtil.xmlType0SCache;
		}
		return window.parent.window.xmlType0SCache;
	}

	static getXmlType1SCache()
	{
		if(AuthorityUtil.xmlType1SCache)
		{
			return AuthorityUtil.xmlType1SCache;
		}
		return window.parent.window.xmlType1SCache;
	}

	static getXmlType1SCacheByUserGroup(userGroupId)
	{
		if(AuthorityUtil.xmlType1OrigCache)
		{
			return AuthorityUtil.xmlType1OrigCache[userGroupId];
		}
		return window.parent.window.xmlType1OrigCache?window.parent.window.xmlType1OrigCache[userGroupId]:null;
	}



	static getAuthorityMenuItemByUserGroup(menuItemId,userGroupId)
	{
		var _parentWindow = window.parent.window;
		var result = {del:false,query:false};
		if(!_parentWindow)return result;

		let userInfos = _parentWindow.userInfos||window.userInfos;
		if(!userInfos)return result;
  		if(userInfos.isAdmin==true)	
			return {del:true,query:true};
		var node = AuthorityUtil.getXmlType1SCacheByUserGroup(userGroupId);
		// var node =AuthorityUtil.getXmlType1SCache();
		if(!node)
		{
			//如果没有设置过第二列权限 返回null 调用者在补全画面权限时按合并后的权限补全
			return node; 
		}
		var _key = GOT.INDEP_FORM_ID+"."+ menuItemId;
		var userGroupNodeInDep = node[_key];
		
		if(userGroupNodeInDep)
		{
			if(userGroupNodeInDep.del == true)
			{
				result["del"] = true;
				result["query"] = true;
			}
			else if(userGroupNodeInDep.query == true)
			{
				result["query"] = true;
			}
			
			
			if(result["del"] == true)
				return result;
		}
		
		
		
		var mainMenu = window.got?window.got.MainMenu:window.parent.window.got.MainMenu;
		var menuItem = GOT.descendantsMainMenu(mainMenu,"MenuItem",menuItemId);
	
		if(menuItem)
		{
			var _key = menuItem.entityId + "." + menuItem.idInMenu;
			var userGroupNode = node[_key];
			if(userGroupNode)
			{
				if(userGroupNode.del == true)
				{
					result.del = true;result.query = true; return result;
				}
				else if(userGroupNode.query == true)
				{
					result.query = true; return result;
				}
				
			}
			else
			{
				//如果没有设置过第二列权限 返回null 调用者在补全画面权限时按合并后的权限补全
				return userGroupNodeInDep?result:null;
			}
		}
		//如果没有设置过第二列权限 返回null 调用者在补全画面权限时按合并后的权限补全
		return userGroupNodeInDep?result:null;
		
	}

	static getAuthorityMenuItem(menuItemId)
	{	
		var _parentWindow = window.parent.window;
		var result = {del:false,query:false};
		if(!_parentWindow)return result;
		let userInfos;
		//zsg 任务系统定制开发
		try
		{
			userInfos = _parentWindow.userInfos||window.userInfos;
		}
		catch(e)
		{
			userInfos = window.userInfos;
		}
		
		if(!userInfos)return result;
  		if(userInfos.isAdmin==true)	
			return {del:true,query:true};
		
		var _key = GOT.INDEP_FORM_ID+"."+ menuItemId;
		var node = AuthorityUtil.getXmlType1SCache()[_key];
			
		
		if(node)
		{
			if(node.del == true)
			{
				result["del"] = true;
				result["query"] = true;
			}
			else if(node.query == true)
			{
				result["query"] = true;
			}
		}
		
		if(result["del"] == true)
			return result;
		
		//var menuItems = [];
		var mainMenu = window.got?window.got.MainMenu:window.parent.window.got.MainMenu;
		var menuItem = GOT.descendantsMainMenu(mainMenu,"MenuItem",menuItemId);
		//for(var i = 0;i<menuItems.length;i++)
		//{
			//var menuItem = menuItems[i];
			if(menuItem)
			{
				var _key = menuItem.entityId + "." + menuItem.idInMenu;
				var node = AuthorityUtil.getXmlType1SCache()[_key];
				if(node)
				{
					if(node.del == true)
					{
						result.del = true;result.query = true; return result;
					}
					else if(node.query == true)
					{
						result.query = true;
					}
				}
			}
		//}
		return result;
	}
}


// WEBPACK FOOTER //
// ./src/utils/AuthorityUtil.js